export const SET_SEARCH_BOX_VALUE = 'SET_SEARCH_BOX_VALUE';
export const setSearchBoxAction = (searchBoxValue) => {
    return {
        type: SET_SEARCH_BOX_VALUE,
        searchBoxValue: searchBoxValue
    }
};